<template>
  <main class="page pto">
    <AppBack :on-back="goToPtoProjectPtoSupply" />

    <AppPageHeader
      v-if="currentItem.request_number"
      :title="`Заявка №${currentItem.request_number}`"
    />

    <section class="section page__content">
      <ThePagePreloader
        v-if="isLoading"
        position="component"
      />

      <div v-if="!isEdit && !isLoading" class="info">
        <PTOProjectTitle />

        <AppButtonSmEdit
          v-if="$store.getters.rightsPtoAll"
          class="info__btn-edit"
          title="Редактировать"
          @click.native="toggleIsEdit"
        />

        <ul class="info__list-edit">
          <PtoInfoListItem
            label-text="Дата заявки"
            :text="currentItem.request_date ? currentItem.request_date : '-'"
          />
          <PtoInfoListItem
            label-text="Срок поставки"
            :text="currentItem.delivery_date ? currentItem.delivery_date : '-'"
          />
          <PtoInfoListItem
            label-text="Согласование тех. директора"
            :text="currentItem.agreement ? getYesOrNo(currentItem.agreement) : '-'"
          />
          <PtoInfoListItem
            label-text="МОЛ"
            :text="currentItem.mol ? getUserFullName(currentItem.mol) : '-'"
          />
        </ul>

        <DropdownJobList
          class="mb-30"
          :job-list="currentItem.jobs"
          disabled-remove
        />
      </div>

      <FormPtoProjectPtoSupply
        v-if="isEdit"
        :form-data="currentItem"
        is-edit
        :is-sending="isSendingRequest"
        @request="sendPutRequest"
        @cancel="toggleIsEdit"
      />
    </section>

    <AppTabsSlider
      :tabs="tabs"
    />

    <router-view />
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack.vue'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppPageHeader from '@/components/page/AppPageHeader'
import AppTabsSlider from '@/components/page/tabs/AppTabsSlider'
import DropdownJobList from '@/components/pto/Job/DropdownJobList'
import FormPtoProjectPtoSupply from '@/components/pto/form/FormPtoProjectPtoSupply'
import PtoInfoListItem from '@/components/pto/listItem/PtoInfoListItem'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import ThePagePreloader from '@/components/page/ThePagePreloader'

import { MIXIN_PTO_PROJECT_PAGE_UPDATE } from '@/mixins/module/pto/project/mixinPTOPageUpdate'

import { mapActions, mapGetters } from 'vuex'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { getUserFullName } from '@/utils/user'
import { goToPage } from '@/utils/router'

export default {
  name: 'PtoProjectPtoSupplyUpdate',
  components: {
    AppBack,
    AppButtonSmEdit,
    AppPageHeader,
    AppTabsSlider,
    DropdownJobList,
    FormPtoProjectPtoSupply,
    PtoInfoListItem,
    PTOProjectTitle,
    ThePagePreloader
  },
  mixins: [MIXIN_PTO_PROJECT_PAGE_UPDATE],
  data: () => ({
    tabs: [
      { name: 'Номенклатура', routeName: 'PtoProjectPtoNomenclature', disabled: false },
      { name: 'Заявки', routeName: 'PtoProjectPtoSupplyRequest', disabled: false }
    ],
    handbooks: [
      'NomenclatureStandard',
      'NomenclatureType',
      'MeasureUnit'
    ]
  }),
  computed: {
    ...mapGetters('pto/project/pto/supply', {
      currentItem: 'getCurrentItem',
      isLoading: 'getIsLoading'
    }),
    initFilter () {
      return {
        supply_id: this.$route.params.id
      }
    }
  },
  async mounted () {
    await this.GETProjectPTOJobList({ projectId: this.$route.params.projectId })
  },
  methods: {
    ...mapActions('handbook/pto', {
      GETProjectPTOJobList: 'GETProjectPTOJobList'
    }),
    ...mapActions('pto/project/pto/supply', {
      loadOneItem: 'loadOneItem',
      updateItem: 'updateItem'
    }),
    getYesOrNo,
    getUserFullName,
    goToPtoProjectPtoSupply () {
      return goToPage('PtoProjectPtoSupply', { projectId: this.$route.params.projectId })
    }
  }
}
</script>
